import { noop } from 'lodash';
import { createContext, Dispatch, FC, PropsWithChildren, SetStateAction, useContext, useState } from 'react';
import { ThemeMode, ThemeName } from '~/app-theme';
import { useLocalStorage } from '~/hooks';

interface ThemeContextProps {
  currentTheme: ThemeName;
  themeMode: ThemeMode;
  setCurrentTheme: Dispatch<SetStateAction<ThemeName>>;
  setThemeMode: Dispatch<SetStateAction<ThemeMode>>;
}

export interface ThemeSettings {
  currentTheme: ThemeName;
  mode: ThemeMode;
}

export const ThemeContextPrivate = createContext<ThemeContextProps>({
  currentTheme: ThemeName.THEME_DEFAULT,
  themeMode: ThemeMode.LIGHT,
  setCurrentTheme: noop,
  setThemeMode: noop,
});

export const useAppThemeContext = () => {
  return useContext(ThemeContextPrivate);
};

export const AppThemeContext: FC<PropsWithChildren<ThemeContextProps>> = ({ children }) => {
  const [themeSettings] = useLocalStorage('THEME_SETTINGS', {
    currentTheme: ThemeName.THEME_DEFAULT,
    mode: ThemeMode.LIGHT,
  });
  const [theme, setTheme] = useState<ThemeName>(
    themeSettings?.currentTheme ? themeSettings?.currentTheme : ThemeName.THEME_DEFAULT
  );
  const [mode, setMode] = useState<ThemeMode>(ThemeMode.LIGHT);
  return (
    <ThemeContextPrivate.Provider
      value={{ currentTheme: theme, themeMode: mode, setCurrentTheme: setTheme, setThemeMode: setMode }}
    >
      {children}
    </ThemeContextPrivate.Provider>
  );
};
